import React from 'react';
import { Grid, Typography, Hidden } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import solutionsClasses from './solutionsStyles.js'
import SolutionsIcon1 from '../../img/survey-icon.png';
import SolutionsIcon2 from '../../img/workflow-icon.png';
import SolutionsIcon3 from '../../img/mobile-icon.png';
import SolutionsIcon4 from '../../img/hosting-icon.png';
import SolutionsIcon5 from '../../img/dev-icon.png';
import SolutionsIcon6 from '../../img/cms-icon.png';

function OurSolutionsCreate() {
  const globalClasses = globalUseStyles()
  const solutionsStyles = solutionsClasses()
  return (
<ThemeProvider theme={theme}>
   <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
      <Grid className={globalClasses.containerSmall} container >
         <Grid item xs={12} sm={12} md={12}  >
            <Typography variant="subtitle1">What We Create</Typography>
            <Typography variant="h2">Our Custom Solutions</Typography>
         </Grid>
         <Hidden mdUp>
            <img className={solutionsStyles.solutionsImg} src={SolutionsIcon1} alt=''/>
        </Hidden>
         <Grid item xs={12} sm={12} md={2}>
            <div className={solutionsStyles.customSolutions1}>
                <div className={solutionsStyles.customSolutionsText}>
                  <Typography className={globalClasses.bold} variant="h5">Survey and Data Collection Systems </Typography>
               </div>
            </div>
         </Grid>
         <Grid item xs={12} sm={12} md={3}>
            <div className={solutionsStyles.customSolutionsSubtext}>
               <Typography className={globalClasses.typSpacing} variant="body2">We can help you better streamline your data in efforts to receive and produce a better, more educated result.  </Typography>
            </div>
         </Grid>
         <Grid item xs={false} sm={false} md={1}/>
        <Hidden mdUp>
            <img className={solutionsStyles.solutionsImg} src={SolutionsIcon2} alt=''/>
        </Hidden>
          <Grid item xs={12} sm={12} md={2}>
            <div className={solutionsStyles.customSolutions2}>
               <div className={solutionsStyles.customSolutionsText}>
                  <Typography className={globalClasses.bold}   variant="h5">Workflow Management</Typography>
               </div>
            </div>
         </Grid>
         <Grid item xs={12} sm={12} md={3}>
            <div className={solutionsStyles.customSolutionsSubtext}>
               <Typography variant="body2">We can build customized workflow management systems that help you streamline your business processes to work more efficiently.  </Typography>
            </div>
         </Grid>
         <Grid item xs={false} sm={false} md={1}/>
        <Hidden mdUp>
            <img className={solutionsStyles.solutionsImg} src={SolutionsIcon3} alt=''/>
        </Hidden>
         <Grid item xs={12} sm={12} md={2}>
            <div className={solutionsStyles.customSolutions3}>
               <div className={solutionsStyles.customSolutionsText}>
                  <Typography className={globalClasses.bold} variant="h5">Mobile Applications</Typography>
               </div>
            </div>
         </Grid>
         <Grid item xs={12} sm={12} md={3}>
            <div className={solutionsStyles.customSolutionsSubtext}>
               <Typography variant="body2">We can help you better provide an on-the-go service and develop applications strictly for mobile use</Typography>
            </div>
         </Grid>
         <Grid item xs={false} sm={false} md={1}/>
        <Hidden mdUp>
            <img className={solutionsStyles.solutionsImg} src={SolutionsIcon4} alt=''/>
        </Hidden>  
         <Grid item xs={12} sm={12} md={2}>
            <div className={solutionsStyles.customSolutions4}>
               <div className={solutionsStyles.customSolutionsText}>
                  <Typography className={globalClasses.bold} variant="h5">Managed Hosting and Migration Services</Typography>
               </div>
            </div>
         </Grid>
         <Grid item xs={12} sm={12}  md={3}>
            <div className={solutionsStyles.customSolutionsSubtext}>
               <Typography variant="body2">Host or migrate your website to our servers for fast performance and support from our team of experts.  </Typography>
            </div>
         </Grid>
         <Grid item xs={false} sm={false} md={1}/>
        <Hidden mdUp>
            <img className={solutionsStyles.solutionsImg} src={SolutionsIcon5} alt=''/>
        </Hidden>
         <Grid item xs={12} sm={12}  md={2}>
            <div className={solutionsStyles.customSolutions5}>
               <div className={solutionsStyles.customSolutionsText}>
                  <Typography className={globalClasses.bold} variant="h5">Custom Application Development</Typography>
               </div>
            </div>
         </Grid>
         <Grid item xs={12} sm={12}  md={3}>
            <div className={solutionsStyles.customSolutionsSubtext}>
               <Typography variant="body2">We can streamline your data into reports and dashboards that help ensure decisions are being made on facts, not opinions.  </Typography>
            </div>
         </Grid>
         <Grid item xs={false} sm={false} md={1}/>
        <Hidden mdUp>
            <img className={solutionsStyles.solutionsImg} src={SolutionsIcon6} alt=''/>
        </Hidden>
         <Grid item xs={12} sm={12}  md={2}>
            <div className={solutionsStyles.customSolutions6}>
               <div className={solutionsStyles.customSolutionsText}>
                  <Typography className={globalClasses.bold} variant="h5">Website Design and CMS Integration</Typography>
               </div>
            </div>
         </Grid>
         <Grid item xs={12} sm={12}  md={3}>
            <div className={solutionsStyles.customSolutionsSubtext}>
               <Typography variant="body2">Whether you are looking for a small or large website, we have the capability to design, build and guide you to a website that will meet your needs.  </Typography>
            </div>
         </Grid>
         <Grid item xs={false} md={1}/>
      </Grid>
   </Container>
</ThemeProvider>
  );
};

export default OurSolutionsCreate;